<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2 col-12">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10 col-12">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Contenido</h2>
                </div>
            </div>


            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-6">
                            <span class="bold">Video Registro:</span><br>
                            <div *ngIf="contenido.video_registro;">
                                <video src="{{environment}}{{contenido.video_registro}}"  width="100%" controls>
                                    Tu navegador no admite el elemento <code>video</code>.
                                </video>
                            </div>

                            <input (change)="videoChangeRegistro($event.target.files)" type="file"accept="video/*" id="video"><br><br>
                            <button class="blanco bold border0 fondoAmarillo" (click)="actualizarVideoRegistro()">Actualizar</button>
                        </div>

                        <div class="col-6">
                            <span class="bold">Video Funnel:</span><br>
                            <div *ngIf="contenido.video;">
                                <video src="{{environment}}{{contenido.video}}"  width="100%" controls>
                                    Tu navegador no admite el elemento <code>video</code>.
                                </video>
                            </div>

                            <input (change)="videoChange($event.target.files)" type="file"accept="video/*" id="video"><br><br>
                            <button class="blanco bold border0 fondoAmarillo" (click)="actualizarVideo()">Actualizar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>